import { render, staticRenderFns } from "./add-company.vue?vue&type=template&id=97bd1614&scoped=true&"
import script from "./add-company.vue?vue&type=script&lang=js&"
export * from "./add-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bd1614",
  null
  
)

export default component.exports